export enum AuthDetails {
    UNAUTHORIZED = 'UNAUTHORIZED',
    NOT_REGISTERED = 'NOT_REGISTERED',
    NOT_CONFIRMED_EMAIL = 'NOT_CONFIRMED_EMAIL',
    EMPTY_COMPANY = 'EMPTY_COMPANY',
    USER_DEACTIVATED = 'USER_DEACTIVATED',
    USER_REJECTED = 'USER_REJECTED',
}
